/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Back_To_LoginInputs */

const en_mobile_back_to_login = /** @type {(inputs: Mobile_Back_To_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to login`)
};

const es_mobile_back_to_login = /** @type {(inputs: Mobile_Back_To_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a iniciar sesión`)
};

/**
* | output |
* | --- |
* | "Back to login" |
*
* @param {Mobile_Back_To_LoginInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_back_to_login = /** @type {((inputs?: Mobile_Back_To_LoginInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Back_To_LoginInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_back_to_login(inputs)
	return en_mobile_back_to_login(inputs)
});